import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import ScrollToTop from '../src/components/scrollToTop'
import FontStyles from "./fontStyles";
import "./styles/global.scss";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <FontStyles />
    <HashRouter>
      <ScrollToTop />
      <App />
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
